import React, { ReactChild } from "react";
import { InView } from "react-intersection-observer";

import { dataAttrTestId } from "@at/formatter-utils/lib/data-attr-utils/data-attr-utils";

import { StyledGalleryImage } from "./gallery-image.styled";

export type ImageInViewHandler = ({
  index,
  src,
}: {
  index: number;
  src: string;
}) => void;

export type ImageOnClickHandler = ({ index }: { index: number }) => void;

type IGalleryImageProps = {
  src: string;
  index: number;
  dataTestId?: string;
  onClick?: ImageOnClickHandler;
  onInView?: ImageInViewHandler;
  children: ReactChild;
};

export const GalleryImage = ({
  src,
  dataTestId,
  index,
  onClick,
  onInView,
  children,
}: IGalleryImageProps) => {
  const handleInViewChange = (inView: boolean) => {
    if (inView) {
      onInView?.({ index, src });
    }
  };

  const _onClick = () => {
    onClick?.({ index });
  };

  return (
    <StyledGalleryImage
      isClickable={!!onClick}
      as={onClick ? "button" : "div"}
      className="image-gallery-item"
      {...{
        [dataAttrTestId]: dataTestId,
      }}
      onClick={_onClick}
    >
      <InView as="div" threshold={0.8} onChange={handleInViewChange}>
        {children}
      </InView>
    </StyledGalleryImage>
  );
};
